import {
    ClickElement,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

async function trackProductItemClicked(label: string, url: string): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'ButtonClick',
        label,
        eventData: {
            eventName: GA4EventName.ClickButton,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            click_element: ClickElement.PDPVariant,
            click_text: label,
            click_url: url,
        },
    });
}

async function trackDropDownOpened(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'Open',
        label: 'OptionsDropdown',
    });
}

async function trackDropdownClicked(label: string, eventName?: GA4EventName): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'DropdownClick',
        label,
        ...(eventName
            ? {
                  eventData: {
                      eventName: GA4EventName.SelectValueVoucherAmount,
                      feature_category: GA4FeatureCategory.ProductdetailBuybox,
                      selected_value: label,
                  },
              }
            : {}),
    });
}

export { trackDropdownClicked, trackDropDownOpened, trackProductItemClicked };
